import avatar from "../assets/avatar.jpg";
import resumePdf from "../assets/RESUME.pdf";

export const profile = {
  name: "Ravi Kant Sharma",
  shortName: "R K Sharma",
  username: "rksharma007",
  title: "Software Development Engineer",
  company: "Amdocs",
  location: "Gurugram, India",
  rank: "Developer",
  education:
    "B.Tech, Software Engineering — Delhi Technological University (9.3 GPA)",
  githubUsername: "rksharma007",
  leetcodeUsername: "rksharma007",
  email: "ravikantsharma635@gmail.com",
  avatar,
  resumePdf,
  tagline: "EAT · <CODE/> · SLEEP · REPEAT",
  bioShort:
    "Full-stack SDE (Java, Spring Boot, Node.js, React/TypeScript) with end-to-end ownership — from real-time telecom billing for 1M+ customers at AT&T to a multi-tenant GenAI platform shipped to 4 clients.",
  bio: [
    "I'm a full-stack Software Development Engineer at Amdocs who likes owning features end to end — from system design through shipping and observability.",
    "I've enhanced real-time telecom billing that migrated 1,000,000+ customers, and re-architected an internal GenAI asset platform into a multi-tenant SaaS product delivered to 4 telecom clients.",
    "B.Tech in Software Engineering from Delhi Technological University (9.3 GPA). I gravitate towards Java + Spring Boot, the MERN stack, GenAI/RAG and system design.",
  ],
  interests: [
    "Full-stack Development",
    "Java + Spring Boot",
    "GenAI / RAG",
    "System Design",
    "MERN Stack",
  ],
  socials: [
    { id: "github", label: "GitHub", url: "https://github.com/rksharma007", username: "rksharma007" },
    {
      id: "linkedin",
      label: "LinkedIn",
      url: "https://www.linkedin.com/in/ravikantsharma007/",
      username: "ravikantsharma007",
    },
    {
      id: "leetcode",
      label: "LeetCode",
      url: "https://leetcode.com/u/rksharma007/",
      username: "rksharma007",
    },
    {
      id: "facebook",
      label: "Facebook",
      url: "https://facebook.com/ravikantsharma07",
      username: "ravikantsharma07",
    },
    {
      id: "instagram",
      label: "Instagram",
      url: "https://www.instagram.com/rksharma3837",
      username: "rksharma3837",
    },
  ],
  contactFormId: "xzbwnqwg",
};

export default profile;
